import { format } from "date-fns/format";
import { parse } from "date-fns/parse";

export function formatDateStr(date: string): string {
  const parsedDate = parse(date, "yyyy-MM-dd HH:mm:ss", new Date());
  return format(parsedDate, "dd/MM/yy HH:mm");
}
